<template>
  <v-card class="legal-entity card pa-4 " :color="bg" flat>
    <div class="d-flex title">
      <v-icon>$editList</v-icon>
      <h2 class="font-Light-16 ms-2 ">
        {{ $t("corporateAccount.membersList.signersList") }}
      </h2>
    </div>
    <template v-if="type === 'SUBMIT'">
      <div
        v-for="item in members"
        :key="item.verification_id"
        class="legal-signer-item flex flex-column flex-sm-row align-center justify-space-between"
        style="gap: 8px 0"
      >
        <span class="font-Light-16 gray2--text">{{ item.name }}</span>
        <!-- <span class="info-status"> ایجاد حساب کاربری</span> -->
        <button
          :class="[
            item.sign_status.title === 'accepted'
              ? 'success-status'
              : 'error-status'
          ]"
          @click="$emit('shareRegisterDialog')"
        >
          {{ item.sign_status.locale }}
        </button>
      </div>
    </template>
    <template v-else>
      <div
        v-for="item in members"
        :key="item.member_id || item.id"
        class="legal-signer-item flex flex-column flex-sm-row align-center justify-space-between"
        style="gap: 8px 0"
      >
        <span class="font-Light-16 gray2--text">{{ item.name }}</span>
        <!-- <span class="info-status"> ایجاد حساب کاربری</span> -->
        <button
          :class="[
            item.status.title === 'accepted' ? 'success-status' : 'error-status'
          ]"
          @click="$emit('shareRegisterDialog')"
        >
          {{ item.status.locale }}
        </button>
      </div>
    </template>
  </v-card>
</template>

<script>
export default {
  name: "MemberList",
  props: {
    type: {
      default: ""
    },
    bg: {
      default: "gray10"
    },
    members: {
      default: []
    }
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
.legal-signer-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;

  &:not(:last-child) {
    border-bottom: 1px solid var(--v-gray6-base);
  }
}
</style>
